import { format, parseISO } from 'date-fns';
import { ko } from 'date-fns/locale';

export const formatWon = (value: number) => `${value.toLocaleString('ko-KR')}원`;

/** 2026.10.13 */
export const formatDate = (date: string) => format(parseISO(date), 'yyyy.MM.dd');

/** A stored timestamp with its own explicit UTC offset, independent of the viewer's timezone. */
export function formatDateTimeWithOffset(date: string) {
  const timestamp = new Date(date);
  const offset = /([+-])(\d{2}):?(\d{2})$/.exec(date);
  const offsetSign = offset?.[1] ?? '';
  const offsetHours = offset?.[2] ?? '00';
  const offsetRemainder = offset?.[3] ?? '00';
  const offsetMinutes = offset
    ? (offsetSign === '+' ? 1 : -1) * (Number(offsetHours) * 60 + Number(offsetRemainder))
    : 0;
  const wallTime = new Date(timestamp.getTime() + offsetMinutes * 60_000);
  const pad = (value: number) => String(value).padStart(2, '0');
  const zone = offset
    ? `${offsetSign}${offsetHours}:${offsetRemainder}`
    : date.endsWith('Z')
      ? '+00:00'
      : '';
  return `${String(wallTime.getUTCFullYear())}.${pad(wallTime.getUTCMonth() + 1)}.${pad(wallTime.getUTCDate())} ${pad(wallTime.getUTCHours())}:${pad(wallTime.getUTCMinutes())} ${zone}`.trim();
}

/** 10월 13일 (월) */
export const formatDayLabel = (date: string) =>
  format(parseISO(date), 'M월 d일 (EEE)', { locale: ko });

/** 오늘 기준 상대 표현 — "오늘", "3일 후", "2일 전" */
export function formatRelativeDays(days: number) {
  if (days === 0) {
    return '오늘';
  }
  return days > 0 ? `${String(days)}일 후` : `${String(-days)}일 전`;
}
